(() => {
  if (!/\/policies\/contact-information\/?$/.test(location.pathname)) return;
  const content = document.querySelector('.shopify-policy__body .rte');
  if (!content || content.classList.contains('mfx-contact-information')) return;
  const paragraphs = [...content.children];
  const entries = paragraphs.map(element => {
    if (element.tagName !== 'P' || element.children.length) return null;
    const match = element.textContent.trim().match(/^([^:]+):\s*(.+)$/s);
    return match ? { element, label: match[1], value: match[2] } : null;
  });
  if (!entries.length || entries.some(entry => !entry)) return;
  const paths = {
    company: 'M3 21h18M6 21V5l6-2 6 2v16M9 8h1m4 0h1M9 12h1m4 0h1M10 21v-5h4v5',
    phone: 'M22 16.9v3a2 2 0 0 1-2.2 2A19.8 19.8 0 0 1 3.1 5.2 2 2 0 0 1 5.1 3h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.4 2.1L9.1 10.8a16 16 0 0 0 4.1 4.1l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2',
    email: 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM2 6l10 7L22 6',
    address: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0ZM15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0',
    registration: 'M5 3h14v18H5ZM8 7h8M8 11h8M8 15h4'
  };
  content.classList.add('mfx-contact-information');
  content.closest('.shopify-policy__container').classList.add('mfx-contact-information-page');
  entries.forEach(({ element, label, value }, index) => {
    let type = 'registration';
    if (index === 0) type = 'company';
    else if (/telefon|telephone/i.test(label)) type = 'phone';
    else if (/e-?mail/i.test(label)) type = 'email';
    else if (/adresse|address/i.test(label)) type = 'address';
    element.classList.add('mfx-contact-card', 'mfx-contact-card--' + type);
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.classList.add('mfx-contact-card-icon');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', paths[type]);
    icon.append(path);
    const copy = document.createElement('span');
    copy.className = 'mfx-contact-card-copy';
    const name = document.createElement('span');
    name.className = 'mfx-contact-card-label';
    name.textContent = label + ': ';
    let detail = document.createElement('span');
    if (type === 'email' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      detail = document.createElement('a');
      detail.href = 'mailto:' + value;
    } else if (type === 'phone') {
      const number = value.replace(/[\s()-]/g, '').replace(/^00/, '+');
      if (/^\+?\d+$/.test(number)) {
        detail = document.createElement('a');
        detail.href = 'tel:' + number;
      }
    }
    detail.className = 'mfx-contact-card-value';
    detail.textContent = value;
    copy.append(name, detail);
    element.replaceChildren(icon, copy);
  });
})();
